import { Button, Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { CheckOutlined, CloseOutlined, DeleteOutlined, DoubleRightOutlined, EditOutlined, HistoryOutlined, PlusOutlined, RollbackOutlined } from '@ant-design/icons';
import { ConfimLottery_Period_Api, DoLottery_Period_Api, GetAllReserves_Period_Api, GetAllWons_Period_Api, GetById_Period_Api } from '../../API/PeriodApi';
import { ReserveStatus } from '../Reserve/ReserveStatus';
import { GetAll_ForPeriod_Api, GetAll_ForPeriod_Paging_Api } from '../../API/ReserveApi';
import { FoodAndParkingStatus } from '../Reserve/FoodAndParkingStatus';
// ======================================================================

export const PeriodFoodsComponent = ({
    setLoading,
    showMessage,
    periodId,
    periodTitle,
    onBackClick,
    onItemClick,
}) => {
    // ======================================================================
    const [reserves, setReserves] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_ForPeriod_Api(periodId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setReserves(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    return (
        <>
            {reserves ?
                <>
                    <Row className='sectionTitle'>
                        <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                            <Button onClick={() => onBackClick()}>
                                <DoubleRightOutlined />
                                بازگشت
                            </Button>
                        </Col>
                        <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                            <h2 >
                               غذا/پارکینگ دوره {periodTitle}
                            </h2>
                        </Col>
                        <Col xs={2} sm={2} md={2} lg={4} xl={4} style={{ textAlign: "left" }}>
                        </Col>
                    </Row>
                    <div className='container'>
                        {reserves ?
                            <>
                                <Row className='titleRow'>
                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='titleColumn'> مکان </Col>
                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} className='titleColumn'> شماره پیگیری </Col>
                                    <Col xs={4} sm={4} md={4} lg={4} xl={4} className='titleColumn'>نفر اصلی</Col>
                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='titleColumn'>از تاریخ  </Col>
                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='titleColumn'>   تا تاریخ </Col>
                                    <Col xs={0} sm={0} md={3} lg={3} xl={3} className='titleColumn'>  زیر دوره  </Col>
                                    <Col xs={5} sm={5} md={5} lg={5} xl={5} className='titleColumn'> وضعیت رزرو غذا </Col>
                                </Row>
                                {reserves.map((reserve, key) =>
                                    <>
                                        {
                                            <>
                                                <Row style={onItemClick ? { cursor: 'pointer' } : {}} onClick={() => onItemClick(reserve.id)} className={reserve.lotteryPriority == 1 ? 'successRow valueRow' : reserve.lotteryPriority > 1 ? 'failRow valueRow' : 'valueRow'}>
                                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='valueColumn'>{reserve.objectInstance.title}</Col>
                                                    <Col xs={3} sm={3} md={3} lg={3} xl={3} className='valueColumn'>  {reserve.trackingCode} </Col>
                                                    <Col xs={4} sm={4} md={4} lg={4} xl={4} className='valueColumn'><b> {reserve.fullName}</b>  </Col>

                                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='valueColumn'>{reserve.from_Shamsi}</Col>
                                                    <Col xs={4} sm={4} md={3} lg={3} xl={3} className='valueColumn'>{reserve.to_Shamsi}</Col>
                                                    <Col xs={0} sm={0} md={3} lg={3} xl={3} className='valueColumn'> {reserve.period.title} </Col>
                                                    <Col xs={5} sm={5} md={5} lg={5} xl={5} className='valueColumn'> <FoodAndParkingStatus foodAndParkingStatus={reserve.foodAndParkingStatus} /> </Col>
                                                </Row>
                                            </>
                                        }
                                    </>
                                )}
                            </>
                            : <></>
                        }
                    </div >


                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>

                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >

                        </Col>
                    </Row>
                </> : <></>
            }
        </>
    )
}
